import React, { Component } from "react";
import { Modal, Breadcrumb, Row, Input, Button, DatePicker, Select, Switch, Tooltip, Checkbox, message } from "antd";
import Table from "CMPT/common/Table";
import { VerifyTypeConfig } from "./userConfig.js";
import { Link } from "react-router-dom";
import moment from 'moment';
import PageInfo from "@/utils/pageInfo.js";
import { UserStatusType, } from 'CMPT/operate/customerConfig'
import { convertEnumToMap } from "CMPT/common.js";
import TableRenderHelp from "@/utils/TableRenderHelp.js";
import UserLabelGroup from './UserLabelGroup';
import UseLabelManagerModal from "./UseLabelManagerModal";
import { API } from "@/http/api";
import { parseBlobReponse } from "@/utils/downloadHelper.js";
import http from "@/http";
import "./UserManager.less";
import NewUser from "./newUser.jsx"
const Option = Select.Option
const { RangePicker } = DatePicker;
const InputSearch = Input.Search;
const BreadcrumbItem = Breadcrumb.Item;

class UserManager extends React.Component {
  state = {
    type: 0,//0：新增1：删除
    tempData: {},
    visible: false,
    crmFlag: '',
    addRecordList: [],
    queryIndex: undefined,
    id: '',
    isExportAuth: false,// 是否具有导出权限

    checkedItem: [],//切换筛选条件，需要重置这个数组。  无论怎么分页，记录都在这里.  
    currentPageRowKeys: [],//当前页的所有数据
    currentPageSelectedRowKeys: [], // 当前页中 被选中的数据


    columns: this.createColumns(),
    pageInfo: new PageInfo(),
    selectedUser: undefined,//  当前被选中的用户，要对其进行标签管理。 

    isBatchSet: false,
    isBatchRevoke: false,

    startDate: undefined,
    endDate: undefined,
    keyword: undefined,
    status: undefined,

    selectedLabelArray: [],

    filterSearchParam: {

    },
    params: {
      pageSize: 10,
      pageNo: 1,
    },
    supplierArray: [
      {
        key: 0,
        value: "失败"
      },
      {
        key: 1,
        value: "成功"
      },
    ],
  };

  rangeChange = (value, date) => {
    let params = this.state.params;
    params.startDate = date[0];
    params.endDate = date[1];
    this.setState({
      params,
      startDate: value[0],
      endDate: value[1]
    }, () => {
      this.getUserlist();
    })
  }
  componentDidMount() {
    this.getUserlist();
    const userform = JSON.parse(localStorage.getItem('userform'))
    this.setState({
      crmFlag: userform.crmFlag,
    })
  }


  resetParams = () => {
    let { params } = this.state;
    params.keyword = '';
    params.startDate = '';
    params.endDate = '';
    params.status = undefined;

    this.setState({
      params,
      startDate: undefined,
      endDate: undefined,
      status: undefined,
      keyword: '',
    }, () => {
      this.getUserlist()
    })
  };


  onSelectChange = currentPageSelectedRowKeys => {
    // 参数
    const i = []
    if (currentPageSelectedRowKeys && currentPageSelectedRowKeys.length > 0) {
      currentPageSelectedRowKeys.forEach(item => {
        i.push(item)
      });
    }
    // 更新
    this.setState({ currentPageSelectedRowKeys, checkedItem: i });
  };

  openCloseChange = (checked, record) => {
    const _this = this
    Modal.confirm({
      title: '确定修改状态吗？',
      onOk() {
        const config = {
          api: API.userManagerSetStatus,
          data: {
            userId: record.id,
            status: record.status == 1 ? 0 : 1
          },
          showLoading: true
        };

        // 请求
        http(config).then(res => {
          if (res.success) {
            _this.getUserlist()
          }
        })
      }
    });

  };

  createColumns() {
    let help = new TableRenderHelp();
    return [
      help.createCommonColumn("姓名", "userName", "userName"),
      help.createCommonColumn("手机号", "mobile", "mobile"),
      help.createCommonColumn("电子邮箱", "email", "email"),
      help.createCommonColumn("统一信用代码", "organizationCode", "organizationCode"),
      help.createCommonColumn("企业名称", "organizationName", "organizationName"),
      help.createCommonColumn("是否管理员", "crmFlag", "crmFlag"),
      help.createCommonColumn("创建人", "createUserName", "createUserName"),
      help.createCommonColumn("创建时间", "createDate", "createDate"),
      help.createOperateColumn("操作", (text, record, index) => {
        let { status } = record;
        return (
          <div>
            <Switch
              checked={status == 1}
              onChange={status => this.openCloseChange(status, record)}
            />
            <span className="status-tip">{status == 1 ? "启用" : "停用"}</span>
            <span style={{ marginLeft: '20px', cursor: 'pointer' }} onClick={() => {
              this.updateUser(record);
            }} >修改</span>
          </div>

        );
      })
    ];
  }
  updateUser = (e) => {
    const config = {
      api: API.authUserDetail,
      path: {
        userId: e.id
      },
      showLoading: true
    };
    http(config).then(res => {
      if (res.code == 200) {
        this.setState({
          visible: true,
          tempData: res.result,
          type: 1,
          id: e.id
        });
      }

    });

  }
  addAddEditDialog() {
    return (
      <NewUser
        id={this.state.id}
        type={this.state.type}
        data={this.state.tempData}
        cancelDialog={this.hideDialog}
        getUserlist={this.getUserlist}
      />
    );
  }

  getUserlist = () => {
    let { params } = this.state;
    const config = {
      api: API.userManageruserManageList,
      data: params
    };
    http(config).then(res => {
      if (res.code == 200) {
        res.result.total = Number(res.result.total)
        this.setState({
          addRecordList: res.result,
        })
      }
    })
  }
  // getUserlist() {
  //   // setup 1: 构造基本参数
  //   let myState = this.state;
  //   console.log("9999", ...myState.filterSearchParam);
  //   let myData = {
  //     ...myState.filterSearchParam,
  //     ...myState.pageInfo
  //   };


  //   // setup 2: 构造 接口入参
  //   const config = {
  //     api: API.userManageruserManageList,
  //     data: myData
  //   };

  //   // 请求
  //   http(config).then(res => {
  //     if (res.code == 200) {
  //       if (!res.result.records) {
  //         res.result.records = [];
  //       }

  //       // 抽取 所有的id ，后面判断选中与否
  //       let { currentPageRowKeys, checkedItem } = this.state;
  //       let currentPageSelectedRowKeys = [];
  //       currentPageRowKeys = [];
  //       res.result.records.forEach(item => {
  //         currentPageRowKeys.push(item.id);

  //         if (checkedItem.indexOf(item.id) >= 0) { //之前被选中了
  //           currentPageSelectedRowKeys.push(item.id);
  //         }
  //       });



  //       this.setState({
  //         queryIndex: new Date().getTime(),
  //         pageInfo: myState.pageInfo.changeFromJson(res.result),
  //         data: res.result.records,
  //         currentPageRowKeys,
  //         currentPageSelectedRowKeys
  //       });
  //     }
  //   });
  // }

  refresh = () => {
    this.getUserlist();
  }


  // 根据时间 进行筛选
  handleDate = (value, date) => {
    // 时间筛选
    let filterSearchParam = this.state.filterSearchParam;
    filterSearchParam.startDate = date[0];
    filterSearchParam.endDate = date[1];

    // 条件有变化，页码需要重置
    let pageInfo = this.state.pageInfo;
    pageInfo.resetPageInfo();

    // 重新查询
    this.setState({
      filterSearchParam,
      pageInfo,
      startDate: value[0],
      endDate: value[1],
      checkedItem: []
    }, this.getUserlist);
  };

  handleUserStatusType = value => {
    // 时间筛选
    let filterSearchParam = this.state.filterSearchParam;
    filterSearchParam.status = value;

    // 条件有变化，页码需要重置
    let pageInfo = this.state.pageInfo;
    pageInfo.resetPageInfo();

    // 重新查询
    this.setState({
      filterSearchParam,
      pageInfo,
      checkedItem: []
    }, this.getUserlist);
  };

  // 关键词筛选
  setKeywords = ({ target: { value } }) => {
    let filterSearchParam = this.state.filterSearchParam;
    filterSearchParam.keyword = value ? value.replace(/^\s+|\s+$/g, "") : "";

    let pageInfo = this.state.pageInfo;
    pageInfo.resetPageInfo();

    this.setState({ filterSearchParam: filterSearchParam, pageInfo });
  };

  searchByKeywords = () => {
    this.setState({
      checkedItem: []
    }, this.getUserlist);
  }


  searchInviteByKeywords = () => {
    this.setState({
      checkedItem: []
    }, this.getUserlist);
  }

  // 页码切换
  tableChange = (pageNo, pageSize, sort) => {
    let pageInfo = this.state.pageInfo;
    pageInfo.changeForClick(pageNo, pageSize);
    this.setState({ pageInfo }, this.getUserlist);
  };


  // 弹出 批量设置
  tryBatchSet = () => {
    this.setState({
      selectedLabelArray: [],// 批量设置和批量取消，共用了这个变量，所以需要重置下
      isBatchSet: true
    });
  }

  // 关闭 批量设置
  cancelOrCloseBatchSet = () => {
    this.setState({
      isBatchSet: false
    });
  }

  tryBatchRevoke = () => {
    this.setState({
      selectedLabelArray: [],// 批量设置和批量取消，共用了这个变量，所以需要重置下
      isBatchRevoke: true
    });
  }

  cancelOrCloseRevoke = () => {
    this.setState({
      isBatchRevoke: false
    });
  }

  // 批量设置
  doBatchSet = () => {
    this.doBatch(true);
  }

  doBatch = (isSet) => {
    // 参数
    let { selectedLabelArray, checkedItem } = this.state;
    const config = {
      api: isSet ? API.labelBatchSet : API.labelBatchCancel,
      data: { labelList: selectedLabelArray, userList: checkedItem },
      showLoading: true
    };

    // 网络请求
    http(config).then(res => {
      if (res && res.success) {
        isSet ? this.cancelOrCloseBatchSet() : this.cancelOrCloseRevoke();
        this.setState({ checkedItem: [], currentPageSelectedRowKeys: [] }, this.refresh);
      }
    });
  }

  // 批量取消
  doBatchRevoke = () => {
    this.doBatch(false); // false就是取消
  }

  // 用户点击了批量设置标签，但需要先检测数据是否符合要求
  tryShowBatchSetModal = () => {
    if (!this.isHaveCheckedUser()) {
      return;
    }

    this.tryBatchSet();
  }

  isHaveCheckedUser = () => {
    let checkedItem = this.state.checkedItem;
    if (!checkedItem || checkedItem.length < 1) {
      message.error("请选择用户");
      return false;
    }

    return true;
  }

  // 用户点击了批量取消标签，但需要先检测数据是否符合要求
  tryShowBatchRevokeModal = () => {
    if (!this.isHaveCheckedUser()) {
      return;
    }

    this.tryBatchRevoke();
  }

  // 给用户 批量打标签的对话框
  createBatchSetModal = () => {
    return <Modal
      visible={true}
      title='批量打标签'
      onCancel={this.cancelOrCloseBatchSet.bind(this)}
      onOk={this.doBatchSet.bind(this)}
    >
      <div>
        <div><span>{'对选择的' + this.state.checkedItem.length + "个用户批量打标签"}</span></div>
        <div><span>请勾选需要打的标签</span></div>
        <div><UserLabelGroup onLabelSelectChange={this.onLabelSelectChange.bind(this)} /></div>
      </div>
    </Modal>
  }

  createBatchRevokeModal = () => {
    return <Modal
      visible={true}
      title='批量取消标签'
      onCancel={this.cancelOrCloseRevoke.bind(this)}
      onOk={this.doBatchRevoke.bind(this)}
    >
      <div>
        <div><span>{'对选择的' + this.state.checkedItem.length + "个用户批量取消标签"}</span></div>
        <div><span>请勾选需要取消的标签</span></div>
        <div><UserLabelGroup onLabelSelectChange={this.onLabelSelectChange.bind(this)} /></div>
      </div>
    </Modal>
  }

  // label变化
  onLabelSelectChange = (checkedValue) => {
    this.setState({ selectedLabelArray: checkedValue });
  }

  closeUserLabelManager = () => {
    this.setState({ selectedUser: null });

  }

  showUserLabelManager = (selectedUser) => {
    this.setState({ selectedUser });
  }

  hideDialog = () => {
    this.setState({
      visible: false
    });
  };
  addUser = () => {
    this.setState({
      visible: true,
      type: 0,
    })
  }
  setAdministrator = () => {
    if (this.state.checkedItem.length == 0) {
      message.error("请先选择用户！")
      return;
    } else {
      const _this = this
      Modal.confirm({
        title: '确定设为管理员？',
        onOk() {
          const config = {
            api: API.userManagerSetAdministrator,
            data: _this.state.checkedItem
          };

          // 请求
          http(config).then(res => {
            if (res.code == 200) {
              message.success("设置成功")
              _this.getUserlist();
            } else {
              message.error(res.msg)
            }
          });
        }
      });
    }
  }
  cancelAdministrator = () => {
    if (this.state.checkedItem.length == 0) {
      message.error("请先选择用户！")
      return;
    } else {
      const _this = this
      Modal.confirm({
        title: '确定取消管理员？',
        onOk() {
          const config = {
            api: API.userManagerCancelAdministrator,
            data: _this.state.checkedItem
          };

          // 请求
          http(config).then(res => {
            if (res.code == 200) {
              message.success("设置成功")
              _this.getUserlist();
            } else {
              message.error(res.msg)
            }
          });
        }
      });
    }
  }
  delAuthUser = () => {
    if (this.state.checkedItem.length == 0) {
      message.error("请先选择用户！")
      return;
    } else {
      const _this = this
      Modal.confirm({
        title: '确定删除吗？',
        onOk() {
          const config = {
            api: API.userManagerDelAuthUser,
            data: _this.state.checkedItem
          };

          // 请求
          http(config).then(res => {
            if (res.code == 200) {
              message.success("删除成功")
              _this.getUserlist();
            }
          });
        }
      });

    }
  }

  //分页
  onChangePage = (pageNo, pageSize, sort) => {
    this.setState(
      {
        params: {
          ...this.state.params,
          pageNo: pageNo,
          pageSize: pageSize,
        },
      },
      () => {
        this.getUserlist();
      }
    );
  };

  changeSupplier = (e) => {
    let params = this.state.params;
    params.status = e;
    this.setState({
      params,
    }, () => {
      this.getUserlist();
    })
  }

  queryStatusSearch = (e) => {
    let params = this.state.params;
    params.status = e;
    this.setState({
      params,
    }, () => {
      this.getUserlist();
    })
  }
  searchChange = (e) => {
    this.setState({
      keyword: e.target.value
    })
  }
  onSearchOn = (e) => {
    let { params } = this.state;
    params.keyword = e;
    this.setState({
      params
    }, () => {
      this.getUserlist()
    })
  }
  render() {
    let mySate = this.state;
    const {
      addRecordList,
      pageInfo,
      keyword,
      params,
      isBatchSet,
      startDate, endDate,
      isBatchRevoke,
      selectedUser,
      supplierArray,
      currentPageSelectedRowKeys,
      isExportAuth
    } = this.state;

    const rowSelection = {
      selectedRowKeys: currentPageSelectedRowKeys,
      onChange: this.onSelectChange,
    };

    return (
      <div className="userlist-content"  >
        <div className='enterprise-auth-header'>
          <Breadcrumb>
            <BreadcrumbItem>用户管理</BreadcrumbItem>
          </Breadcrumb>
        </div>
        <div className="userlist-body">
          <Row>

            <span>
              <Select allowClear showSearch optionFilterProp="label" value={params.status} onChange={this.changeSupplier} onSearch={this.queryStatusSearch}
                placeholder="状态" style={{ width: '100px', display: 'inline-block' }}>
                {supplierArray.map(item => (
                  <Option key={item.key} value={item.key} label={item.value}>
                    <span>{item.value}</span>
                  </Option>
                ))}
              </Select>
            </span>

            <span>
              <span style={{ marginRight: "5px" }}>创建时间</span>
              <RangePicker value={[startDate, endDate]} onChange={this.rangeChange} style={{ marginRight: '12px' }} />
            </span>

            <span>
              <InputSearch
                placeholder="手机号/姓名/所属企业"
                onChange={this.searchChange}
                onSearch={this.onSearchOn}
                value={keyword}
                style={{ width: "280px" }}
                maxLength={50}
              />
            </span>

            <span
              span={3}
              className="reset"
              style={{
                cursor: "pointer",
                fontSize: "12px",
                textDecoration: "underline",
                textUnderlinePosition: "under",
                color: "#333"
              }}
              onClick={this.resetParams.bind(this)}
            >
              <a >重置</a>
            </span>

            <Button type="primary" style={{ marginLeft: '10px' }} onClick={this.addUser}>新增</Button>
            {
              this.state.crmFlag == 2 ?
                <Button type="primary" style={{ marginLeft: '10px' }} onClick={this.setAdministrator}>设为管理员</Button>
                : ''
            }
            {
              this.state.crmFlag == 2 ?
                <Button type="primary" style={{ marginLeft: '10px' }} onClick={this.cancelAdministrator}>取消管理员权限</Button>
                : ''
            }
            {
              this.state.crmFlag == 2 ?
                <Button type="primary" style={{ marginLeft: '10px' }} onClick={this.delAuthUser}>删除</Button>
                : ''
            }
            {this.state.visible ? this.addAddEditDialog() : ""}
          </Row>
          <Table
            rowSelection={rowSelection}
            rowKey="id"
            columns={mySate.columns}
            selfProcessData={addRecordList && addRecordList.records}
            total={addRecordList && addRecordList.total}
            change={this.onChangePage}
            current={addRecordList && addRecordList.current}
          />
        </div>

        {isBatchSet && this.createBatchSetModal()}
        {isBatchRevoke && this.createBatchRevokeModal()}

        {selectedUser ?
          <UseLabelManagerModal
            userCode={selectedUser.code}
            userName={selectedUser.name}
            userPhone={selectedUser.mobile}
            onRefresh={this.refresh}
            onCancel={this.closeUserLabelManager} /> : ''}
      </div>
    );
  }
}


export default UserManager;
